var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.938,
    height: 29.938,
    viewBox: "0 0 29.938 29.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "expand",
    x: 0,
    y: 0,
    width: 29.938,
    height: 29.938,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.353
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#expand)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "expand-2",
    "data-name": "expand",
    d: "M-13102.494,1860.234a.834.834,0,0,1-.834-.833.834.834,0,0,1,.834-.834h3.555l-5.536-5.534a.834.834,0,0,1,0-1.179.836.836,0,0,1,1.181,0l5.534,5.535v-3.555a.834.834,0,0,1,.834-.834.833.833,0,0,1,.833.834v5.567a.833.833,0,0,1-.833.833Zm-16.7,0a.834.834,0,0,1-.835-.833v-5.567a.834.834,0,0,1,.835-.834.833.833,0,0,1,.833.834v3.555l5.533-5.535a.836.836,0,0,1,1.181,0,.834.834,0,0,1,0,1.179l-5.534,5.534h3.554a.834.834,0,0,1,.835.834.835.835,0,0,1-.835.833Zm14.889-15.722a.831.831,0,0,1,0-1.179l5.368-5.368h-3.555a.834.834,0,0,1-.834-.834.834.834,0,0,1,.834-.835h5.567a.834.834,0,0,1,.833.835v5.567a.833.833,0,0,1-.833.834.834.834,0,0,1-.834-.834v-3.555l-5.368,5.368a.833.833,0,0,1-.591.245A.829.829,0,0,1-13104.308,1844.512Zm-8.687,0-5.369-5.368v3.555a.834.834,0,0,1-.835.834.833.833,0,0,1-.833-.834v-5.567a.834.834,0,0,1,.833-.835h5.568a.835.835,0,0,1,.835.835.835.835,0,0,1-.835.834h-3.556l5.37,5.368a.833.833,0,0,1,0,1.179.832.832,0,0,1-.59.243A.83.83,0,0,1-13112.994,1844.512Z",
    transform: "translate(13123.03 -1834.3)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.b65de8317c61e37da68b8a6f2ed3cd60.svg";
export { ForwardRef as ReactComponent };